import type { QueryStatus } from '@tanstack/query-core';

import type { PopoverProps } from 'Storybook/core/Popover';

import type { UseDownloadCsvPollingProps } from './useDownloadCsvPolling/useDownloadCsvPolling';

export enum DownloadToastType {
	AbortedFilter = 'abortedFilter',
	AbortedPage = 'abortedPage',
	Failed = 'failed',
	Pending = 'pending',
}

export enum PollingState {
	AbortedFilter = 'AbortedFilter',
	AbortedPage = 'AbortedPage',
	Error = 'Error',
	Inactive = 'Inactive',
	Polling = 'Polling',
	RetriesLimitExceeded = 'RetriesLimitExceeded',
	Success = 'Success',
}

export type DownloadToastPollingState =
	| PollingState.Error
	| PollingState.RetriesLimitExceeded
	| PollingState.AbortedFilter
	| PollingState.AbortedPage
	| PollingState.Polling;

export type DownloadCSVHandlers = {
	onDownloadButtonClick?: () => void;
	onDownloadButtonHover?: () => void;
	onDynamicDownloadButtonClick?: () => void;
	onDynamicDownloadButtonHover?: () => void;
	onPollingAborted?: () => void;
	onPollingError?: () => void;
	onPollingSuccess?: () => void;
	onPopoverDownloadButtonClick?: (selected?: string) => void;
};

export type DynamicDownloadOptionsProps = {
	alignment?: PopoverProps['contentAlign'];
	cypressId?: string;
	items: {
		cypressId?: string;
		id: string;
		label: string;
		staticDownloadUrl?: string;
	}[];
	title: string;
};

export type DownloadCSVProps = {
	className?: string;
	cypressId?: string;
	downloadButtonLabel?: string;
	dynamicDownloadOptions?: DynamicDownloadOptionsProps;
	handlers?: DownloadCSVHandlers;
	isDisabled?: boolean;
	isDynamic?: boolean;
	pollingProps?: UseDownloadCsvPollingProps;
	queryStatus?: QueryStatus;
	staticDownloadUrl?: string;
	tooltip?: string;
};

export type DownloadCSVStateProps = {
	isDisabled?: boolean;
	isLoading?: boolean;
	isPopoverOpen?: boolean;
};
